
import React, { useState, useEffect } from 'react';
import axios from 'axios';
// models
import { User } from '../../entities/user';
// components
import TextInput from '../inputs/TextInput';
import Debounce from '../inputs/Debounce';
// services
import AuthService from '../../services/auth';

const MIN_CHAR_SEARCH = 2;

interface UserSearchProps {
    onResults(users: User[]): void;
    onIsSearching(isSearching: boolean): void;
}

const UserSearch: React.FC<UserSearchProps> = (props) => {

    const [users, setUsers] = useState<User[]>([]);

    const [searchTerm, setSearchTerm] = useState<string>('');
    const debouncedSearchTerm = Debounce(searchTerm, 500);
    // const node: any = useRef();

    const fetchUsers = async (termSearch: string) => {
        const usersRes = await axios.post(`${AuthService.getApiUrls().user}/users/_search`, {
            "query": {
                "multi_match": {
                    "query": termSearch,
                    "type": "phrase_prefix",
                    "fields": ["name", "email"]
                }
            }
        });
        props.onResults(usersRes.data.results);
        props.onIsSearching(false);
    }

    const handleSearchChange = (searchTermText: string) => {
        setSearchTerm(searchTermText);
        if (searchTermText.length > MIN_CHAR_SEARCH) {
            props.onIsSearching(true);
        }
    }

    useEffect(
        () => {
            if (debouncedSearchTerm) {
                props.onIsSearching(true);
                fetchUsers(debouncedSearchTerm);
            } else {
                props.onIsSearching(false);
                props.onResults([]);
            }
            // document.addEventListener('mouseup', handleClick, false);
            // document.addEventListener('keydown', handleKeydown, false);
            return () => {
                // document.removeEventListener('mouseup', handleClick, false);
                // document.removeEventListener('keydown', handleKeydown, false);
            }
        },
        [debouncedSearchTerm]
    );

    return (
        <div>
            <TextInput
                title=""
                type="string"
                placeholder="Search users"
                result={searchTerm}
                onChange={(event: any) => handleSearchChange(event.target.value)}
            />
        </div>
    );
};

export default UserSearch;


// WEBPACK FOOTER //
// ./src/components/site/UserSearch.tsx